import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import PageLayout from "@/components/PageLayout";
import { faqs, generateFAQSchema } from "@/data/faq";

const faqSchema = generateFAQSchema(faqs);

const FAQ = () => {
  return (
    <PageLayout
      seo={{
        title: "FAQ - Eunice Travel Letters",
        description: "Common questions about Eunice personalized travel letters. How it works, delivery time, what's included, and more.",
        canonical: "/faq",
        schema: faqSchema,
      }}
    >
      {/* Back link */}
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors mb-8"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Back to home
      </Link>

      {/* Section header */}
      <header className="text-center mb-10 md:mb-12">
        <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-muted-foreground mb-2 md:mb-3 font-sans">
          Questions & Answers
        </p>
        <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground mb-3 md:mb-4">
          Frequently Asked Questions
        </h1>
        <p className="text-base md:text-lg text-charcoal-light font-sans">
          Here are answers to the questions travelers ask most often.
        </p>
      </header>

      {/* FAQ List */}
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <article key={index} className="bg-cream-dark/50 border border-tan/30 rounded-lg px-5 md:px-6 py-5">
            <h2 className="font-serif text-base md:text-lg text-foreground mb-3">
              {faq.question}
            </h2>
            <p className="text-charcoal-light font-sans text-sm md:text-base leading-relaxed">
              {faq.answer}
            </p>
          </article>
        ))}
      </div>

      {/* CTA to order */}
      <div className="mt-10 p-6 bg-primary/5 border border-primary/20 rounded-lg text-center">
        <p className="text-foreground font-serif text-lg mb-3">
          Ready to get your letter?
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-primary hover:underline font-medium"
        >
          Request a letter from Eunice
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>

      {/* Contact prompt */}
      <p className="text-center mt-8 md:mt-10 text-sm text-muted-foreground font-sans">
        Still have questions?{" "}
        <a
          href="mailto:letters@eunice.world"
          className="text-primary hover:underline"
        >
          Email us at letters@eunice.world
        </a>
      </p>
    </PageLayout>
  );
};

export default FAQ;
